/**
 * updates entity with new data in the array
 *
 * @export
 * @template T
 * @param {string} updatedEntityId
 * @param {Partial<T>} updatedEntityData
 * @param {T[]} allEntities
 * @return {*}  {T[]}
 */
export function updateEntityInArray<T = any>(
  updatedEntityId: string,
  updatedEntityData: Partial<T>,
  allEntities: T[],
): T[] {
  if (allEntities?.length > 0) {
    const updatedEntity: T =
      allEntities?.find((entity) => entity['id'] === updatedEntityId) || <T>{};
    const updatedEntitiesWithNewData = <T>{
      ...updatedEntity,
      ...updatedEntityData,
    };
    const updatedEntities: T[] = [
      ...allEntities.filter((entity) => entity['id'] !== updatedEntityId),
      updatedEntitiesWithNewData,
    ];
    return updatedEntities;
  } else {
    return <T[]>[];
  }
}
